import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';

const DollarInput = function DollarInput(props) {
    const {
        children,
        placeholder,
        invalidclass,
        validation,
    } = props;

    const input = flattenChildren(children).find((c) => isType(c, 'input'));
    const { defaultValue } = input.props;

    const [value, setValue] = useState(defaultValue === '0.00' ? '' : defaultValue);

    const newInput = React.cloneElement(
        input,
        {
            type: 'number',
            placeholder,
            onInput: (event) => {
                const newValue = event.target.value;

                const error = newValue < 1
                    ? 'Please enter a value'
                    : '';

                setValue(newValue);

                if (validation) {
                    validation(event, error);
                }
            },
            defaultValue: value ?? defaultValue,
            className: `${input.props.className} ${invalidclass} ${styles['dollar-input']}`,
            'data-testid': `${input.props.name}-input`,
        },
    );

    return (
        <div className={styles['dollar-input']}>
            <span>$</span>
            {newInput}
        </div>
    );
};

DollarInput.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    placeholder: PropTypes.string,
    invalidclass: PropTypes.string,
};

DollarInput.defaultProps = {
    placeholder: '',
    validation: () => { },
    invalidclass: '',
};

export default DollarInput;
